import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Form,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { activateOperatorUser } from "../../../helpers/backend_helper";
import NibbleInput from "../../../components/Fields/NibbleInput";

const ActivateUserModal = ({ modal, setModal, items, setItems }) => {
  const operator = modal.operator ?? {};
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setModal({ show: false, operator: null });
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: operator.email ?? "",
      password: "",
      password_confirmation: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Ingresa un correo válido")
        .required("Ingresa el correo electrónico"),
      password: Yup.string()
        .required("Ingresa una contraseña")
        .min(8, "La contraseña debe tener al menos 8 caracteres"),
      password_confirmation: Yup.string()
        .required("Repite la contraseña")
        .oneOf([Yup.ref("password")], "Las contraseñas no coinciden"),
    }),
    onSubmit: async (values) => {
      await save(values);
    },
  });

  const save = async (data) => {
    setLoading(true);
    const response = await activateOperatorUser(operator.id, data);
    setLoading(false);
    if (response.status) {
      const newItem = response.operator;
      setItems(items.map((i) => (i.id !== newItem.id ? i : newItem)));
      handleClose();
    } else if (response.errors) {
      const serverErrors = {};
      Object.keys(response.errors).forEach((key) => {
        const messages = response.errors[key];
        serverErrors[key] = Array.isArray(messages) ? messages[0] : messages;
      });
      validation.setErrors(serverErrors);
    }
  };

  return (
    <Modal isOpen={modal.show}>
      <ModalHeader className="bg-primary">
        Activar usuario — {operator.full_name}
      </ModalHeader>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();
          return false;
        }}
      >
        <ModalBody>
          <div className="row">
            <NibbleInput
              md={12}
              label="Correo electrónico:"
              fieldName="email"
              fieldType="text"
              validation={validation}
            />
            <NibbleInput
              md={12}
              label="Contraseña:"
              fieldName="password"
              fieldType="password"
              validation={validation}
            />
            <NibbleInput
              md={12}
              label="Repite contraseña:"
              fieldName="password_confirmation"
              fieldType="password"
              validation={validation}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" type="submit" disabled={loading}>
            {loading && <Spinner size="sm"></Spinner>}{" "}
            <i className="fa fa-save"></i> Guardar
          </Button>{" "}
          <Button color="secondary" onClick={handleClose}>
            <i className="fa fa-times"></i> Cancelar
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default ActivateUserModal;
